import { LegalLayout, LegalSection } from "../components/Legal";

export default function AccessibilityPage() {
  return (
    <LegalLayout badge="Legal" title="Accessibility Statement" testid="accessibility-page">
      <LegalSection title="Our Commitment to Accessibility">
        <p>
          Cindyrella Cleaning LLC is committed to making our website accessible to everyone,
          including people with disabilities. We believe every visitor should be able to learn
          about our services, request an estimate, and contact us with ease.
        </p>
      </LegalSection>
      <LegalSection title="Standards We Work Toward">
        <p>
          We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA,
          the standard referenced by the Americans with Disabilities Act (ADA) for digital
          accessibility. Our ongoing efforts include:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Clear headings, readable fonts, and sufficient color contrast.</li>
          <li>Descriptive text for images and meaningful link labels.</li>
          <li>A website that can be navigated by keyboard and works with screen readers.</li>
          <li>Forms and estimate tools designed to be simple and easy to complete.</li>
        </ul>
      </LegalSection>
      <LegalSection title="Alternative Ways to Reach Us">
        <p>
          If any part of our website is difficult to use, you can always reach us directly by
          phone or text at (239) 244-1934 or by email at info@cindyrellaclean.com. We are happy to
          provide any information from this website, or take your estimate request, by phone or
          email.
        </p>
      </LegalSection>
      <LegalSection title="Feedback">
        <p>
          Accessibility is an ongoing effort. If you encounter an accessibility barrier on our
          website, please let us know at info@cindyrellaclean.com — we take this feedback
          seriously and will work to address issues promptly.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
